// Copyright © 2025 The Things Industries B.V.

import React from 'react'

import Breadcrumb from '@ttn-lw/components/breadcrumbs/breadcrumb'
import { useBreadcrumbs } from '@ttn-lw/components/breadcrumbs/context'

import IntlHelmet from '@ttn-lw/lib/components/intl-helmet'

import LabelsTable from '@console/containers/labels-table/index.tti'

import sharedMessages from '@ttn-lw/lib/shared-messages'

const LabelsList = () => {
  useBreadcrumbs(
    'overview.labels.list',
    <Breadcrumb path="/labels" content={sharedMessages.list} />,
  )

  return (
    <div className="container container--xxl p-0">
      <IntlHelmet title={sharedMessages.labels} />
      <LabelsTable />
    </div>
  )
}

export default LabelsList
